import React, {
    useState,
    useRef,
    useEffect,
    useCallback,
    useContext,
  } from "react";
  
   
  import { useSpring, animated } from "react-spring";
  import { MdClose } from "react-icons/md";
  import { RewardManagementContext } from "../context/RewardManagementContext";
  import { toast } from "react-toastify";
  
  const ModalTransfer = ({ showModalTransfer, setShowModalTransfer, formValues, setFormValues}) => {
  
    const initialValue = { blockTime: "", currentTier: "0" };
    //const [formValues, setFormValues] = useState(initialValue);
    const { upgradeNode } = useContext(RewardManagementContext);
    
    const upgradeNodeTier = (createTime) => {
      upgradeNode(createTime);
    }
  
    return (
      <>
        {showModalTransfer ? (
          <div className="createNode ">
            <form>
              <div className="model-head">
                <a
                  className="closeBtn"
                  onClick={() => setShowModalTransfer((prev) => !prev)}
                >
                  <MdClose />
                </a>
                <p className="text-justify">
                [UNDER DEVELOPMENT] Please provide the wallet address for the account you need to transfer this Node.
                </p>
              </div>
  
              <div className="model-footer">
                <div className="mt-2 text-white text-xs mt-2">
                  
                </div>
                <div className="text-white text-xs mt-2">
                  {/* <p>Your $MSTATE token will be distributed as follows:</p> */}
                  <ul>
                    <li>Current Owner: </li>
                    <li>Transfer To: <br/>
                    <input
                  className="my-2 w-full rounded-sm p-2 outline-none bg-transparent text-white border-white text-sm white-glassmorphism"
                  placeholder="New Owner Address"
                  name="transferAddress"
                  type="text"
                  
                />
                    </li>                                      
                  </ul>
  
                   
                  <div className="mt-2 mb-2 p-0 flex flex-row justify-end items-center rounded-md place-items-end">
                    <a className="btn "  >
                      <span>Proceed</span>
                    </a>
  
                    <a className="btn " onClick={() => setShowModalTransfer((prev) => !prev)} >
                      <span>Cancel</span>
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
        ) : null}
      </>
    );
  };
  export default ModalTransfer;
  